var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.09C0 24.043 5.777 30.658 13.333 32V20.444h-4V16h4v-3.556c0-4 2.578-6.221 6.223-6.221 1.155 0 2.4.177 3.555.354v4.09h-2.044c-1.956 0-2.4.977-2.4 2.222V16h4.266l-.71 4.444h-3.556V32C26.223 30.659 32 24.045 32 16.09 32 7.24 24.8 0 16 0S0 7.24 0 16.09z",
    fill: "#343434"
  })));
}
export default SvgFacebook;